export function formatPlural(
	number: number | string,
	singularText: string,
	pluralText?: string,
) {
	if (Number.isNaN(Number(number))) {
		return "";
	}

	if (Number(number) === 1) {
		return `1 ${singularText}`;
	}

	if (pluralText) {
		return `${number} ${pluralText}`;
	}

	return `${number} ${singularText}s`;
}
